// cSpell:ignore Silae mtpart
import type { SilaeVariable } from "@/types/silae";
import type { FormatterContext } from "./types";

const PREDEFINED_VARIABLE_FALLBACKS: Record<string, string> = {
  VAR_SALARY_BASE: "Salaire de base",
  VAR_SALARY_GROSS: "Salaire brut",
  VAR_SALARY_NET: "Salaire net",
  VAR_CONTRACT_TYPE: "Type de contrat",
  VAR_PROFESSIONAL_STATUS: "Statut professionnel",
  VAR_EMPLOYEE_CATEGORY: "Catégorie personnel",
  VAR_AGE: "Âge du salarié",
  VAR_SENIORITY: "Ancienneté",
  VAR_MONTH: "Mois du bulletin",
  VAR_YEAR_CURRENT: "Année du bulletin",
  VAR_IS_EXECUTIVE: "Statut cadre",
};

const PREDEFINED_VARIABLE_KEYS: Record<string, string> = {
  VAR_SALARY_BASE: "salaryBase",
  VAR_SALARY_GROSS: "salaryGross",
  VAR_SALARY_NET: "salaryNet",
  VAR_CONTRACT_TYPE: "contractType",
  VAR_PROFESSIONAL_STATUS: "professionalStatus",
  VAR_EMPLOYEE_CATEGORY: "employeeCategory",
  VAR_AGE: "age",
  VAR_SENIORITY: "seniority",
  VAR_MONTH: "month",
  VAR_YEAR_CURRENT: "yearCurrent",
  VAR_IS_EXECUTIVE: "isExecutive",
};

export function formatPredefinedVariableLabel(
  conditionType: string,
  ctx: FormatterContext,
): string {
  const key = PREDEFINED_VARIABLE_KEYS[conditionType];
  const fallback = PREDEFINED_VARIABLE_FALLBACKS[conditionType];
  if (!key) return fallback ?? conditionType;
  return ctx.t(
    `step5Validation.formatters.predefined.${key}`,
    fallback ?? conditionType,
  );
}

export function resolveVariableLabel(
  variable: SilaeVariable | undefined,
  fallbackCode: string,
): string {
  if (!variable) return fallbackCode;
  return variable.label || variable.displayName || variable.code;
}

export function resolveOptionLabel(
  options: Array<{ label: string; code: string }> | undefined,
  optionCode: string,
): string {
  if (!options || !optionCode) return optionCode;
  const match = options.find((o) => o.code === optionCode);
  return match?.label ?? optionCode;
}

// Append a unit to a numeric value if not already implied by the surrounding label.
export function appendUnit(value: string, unit?: string): string {
  if (!unit) return value;
  const trimmed = value.trim();
  if (!trimmed) return value;
  const lower = trimmed.toLowerCase();
  if (lower.endsWith(unit.toLowerCase())) return value;
  // Compact glyphs glue without space; word units take a space.
  const gluedUnits = ["€", "%"];
  if (gluedUnits.includes(unit)) return `${trimmed} ${unit}`;
  return `${trimmed} ${unit}`;
}
